import { useProductData } from "@product-details/hooks/useProductData";
import { useConsumablesProductDetailsContext } from "@product-details/providers/ConsumablesProductDetailsProvider";

export const useConsumablesProductData = (): ReturnType<typeof useProductData> => {
  const { currentMatrixItem } = useConsumablesProductDetailsContext();

  const consumablesProductData = useProductData({
    sku: currentMatrixItem.sku,
    currentVariantSku: currentMatrixItem.sku,
  });

  return consumablesProductData;
};
